import React from "react"
import Item from "../../assets/images/gentamycin.png"
import { Link } from "react-router-dom"

function StoreData() {
  return (
    <div className="container">
      <div className="store row">
        <div className="col-lg-4 col-md-6 m-auto ">
          <div className=" store__items col-12">
            <img src={Item} alt="loading" />
            <div className="store__items__description">
              <p className="store__items__description__title">Gentamycin</p>
              <p>Tablet 50 pieces</p>
            </div>
            <div className="store__items__label">
              <span className="store__items__label__price">₦1,570</span>
              <Link to="/buy" className="store__items__label__button">Buy</Link>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 m-auto ">
          <div className=" store__items col-12">
            <img src={Item} alt="loading" />
            <div className="store__items__description">
              <p className="store__items__description__title">Gentamycin</p>
              <p>Tablet 50 pieces</p>
            </div>
            <div className="store__items__label">
              <span className="store__items__label__price">₦1,570</span>
              <Link to="/buy" className="store__items__label__button">Buy</Link>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 m-auto ">
          <div className=" store__items col-12">
            <img src={Item} alt="loading" />
            <div className="store__items__description">
              <p className="store__items__description__title">Gentamycin</p>
              <p>Tablet 50 pieces</p>
            </div>
            <div className="store__items__label">
              <span className="store__items__label__price">₦1,570</span>
              <Link to="/buy" className="store__items__label__button">Buy</Link>
            </div>
          </div>
        </div>

      </div>

    </div>
  )
}

export default StoreData;